import React from 'react';
import { Box, Typography } from '@mui/material';
import IsMobile from '../../../../hooks/isMobile';
import CarretDown from '../../../../assets/svg-fc/CarretDown';
import palette from '../../../../theme/palette';
import './collapsibleCardHeader.scss';

interface ICollapsibleCardHeaderProps {
  isExpanded: boolean;
  title: string;
  handleToggle: () => void;
}

const CollapsibleCardHeader: React.FC<ICollapsibleCardHeaderProps> = ({ isExpanded, title, handleToggle }) => {
  const isMobile = IsMobile();
  return (
    <Box className="collapsibleCardHeader" onClick={() => isMobile && handleToggle()}>
      <Typography className="collapsibleCardHeaderTitle">{title}</Typography>
      {isMobile && (
    <Box onClick={handleToggle} sx={{
      height: "24px"
    }}>
          <CarretDown
            style={{
              width: '24',
              height: '24',
              color: palette.secondary.main,
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease-in-out',
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default CollapsibleCardHeader;
